import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Subscription, take } from 'rxjs';
import { CustomProfileAndPreferencesService } from '../custom-profile-and-preferences.service';

@Component({
    selector: 'app-profile-preference-banner',
    templateUrl: './profile-preference-banner.component.html',
    styleUrl: './profile-preference-banner.component.scss',
    standalone: false
})
export class ProfilePreferenceBannerComponent implements AfterViewInit, OnDestroy {
  baseSiteId: string;
  subscription: Subscription;
  showBanner: boolean;
  element: any;

  constructor(
    private baseSiteService: BaseSiteService,
    private readonly pfService: CustomProfileAndPreferencesService,
  ) {
    this.baseSiteService.getActive().pipe(take(1)).subscribe((res) => this.baseSiteId = res);
  }

  ngAfterViewInit() {
    this.element = document.querySelectorAll('.BannerContent')[0];
    this.element?.setAttribute('class', 'BannerContent mfaBanner');
    this.subscription = this.pfService.userData.subscribe((userData) => {
      if (!!userData?.res?.mobileNumber) this.closeBanner();
    });
  }

  closeBanner() {
    this.element?.setAttribute('style', 'display:none !important');
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}